module.exports = __webpack_public_path__ + "images/img-t8sf3FJ.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/ranks/2.jpg
// module id = 2035
// module chunks = 0